import { render } from "./Login.vue?vue&type=template&id=5cf410f1"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=5cf410f1&lang=scss"
script.render = render

export default script